export { SUPPORTED_LOCALES, type SupportedLocaleType } from '@repo/config';
